<template>
    <div class="fixed">
        <!-- 入口按钮 - 未打开弹窗时显示 -->
        <div class="msgTips" v-if="!msgBox.show" @click="openMsgBox">
            <i class="el-icon-message-solid"></i>
            在线咨询
            <div class="unread-count" v-if="totalUnreadCount > 0">
                {{ totalUnreadCount > 99 ? '99+' : totalUnreadCount }}
            </div>
        </div>

        <!-- 主弹窗 -->
        <div class="msgBox" v-if="msgBox.show">
            <!-- 聊天内容区域 -->
            <div class="chatBox" v-if="chatBox.show">
                <div class="chat-content">
                    <div class="message-group">
                        <div class="message-header">
                            <h4>{{ currentChatInfo ? currentChatInfo.name : '经纪人' }}</h4>
                            <div class="header-actions">
                                <i class="el-icon-close back" @click="backToConversationList"></i>
                            </div>
                        </div>
                        <div class="messages" ref="messagesContainer" @scroll.passive="handleScroll">
                            <!-- 顶部加载提示 -->
                            <div class="top-loading-more" v-if="isLoadingMore">
                                <i class="el-icon-loading"></i> 加载更早消息...
                            </div>
                            <div class="no-more-history" v-if="!hasMoreHistory && messageGroups.length > 0">
                                <span>没有更多历史消息了</span>
                            </div>

                            <!-- 无消息提示 -->
                            <div v-if="messageGroups.length === 0 && !isLoadingHistory && !isLoadingMore"
                                class="empty-messages">
                                <i class="el-icon-chat-dot-round"></i>
                                <p>暂无消息，开始聊天吧~</p>
                            </div>

                            <div v-for="msg in sortedMessageGroups" :key="msg.uniqueId" class="message-item"
                                :class="[msg.isSelf ? 'self' : 'other']">
                                <div class="avatar" v-if="!msg.isSelf">
                                    <img
                                        :src="currentChatInfo ? (currentChatInfo.avatar || agentAvatar) : agentAvatar" />
                                </div>
                                <div class="avatar" v-if="msg.isSelf">
                                    <img :src="user.customer ? (user.customer.avatar || agentAvatar) : agentAvatar" />
                                </div>

                                <div class="message-bubble" :class="[msg.contentType === 4 ? 'house-card' : '']">
                                    <template v-if="msg.contentType === 1">
                                        <p>{{ msg.content }}</p>
                                    </template>
                                    <template v-else-if="msg.contentType === 2">
                                        <img class="message-image" :src="msg.content" @click="previewImage(msg.content)"
                                            @load="onImageLoad" @error="onImageError" />
                                    </template>
                                    <template v-else-if="msg.contentType === 4">
                                        <div class="house-card-content" @click="goToHouseDetail(msg.houseData)">
                                            <img class="house-image"
                                                :src="!msg.houseData.coverImage ? defaultHouseImage : msg.houseData.coverImage" />
                                            <div class="house-info">
                                                <div class="house-title">{{ msg.houseData.title }}</div>
                                                <div class="house-desc">
                                                    <span>{{ msg.houseData.room }}室{{ msg.houseData.hall }}厅</span>
                                                    <span>{{ msg.houseData.buildingArea }}㎡</span>
                                                </div>
                                                <div class="house-price" v-if="msg.houseData.tradeType == 1">
                                                    {{ msg.houseData.rentPrice }}元/月
                                                </div>
                                                <div class="house-price" v-else-if="msg.houseData.tradeType == 2">
                                                    {{ msg.houseData.priceShow }}万
                                                    <span class="unit-price">{{ msg.houseData.unitPrice }}元/㎡</span>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <p>{{ msg.content }}</p>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="message-input-area">
                    <div class="message-input-wrapper">
                        <input type="text" placeholder="点击输入您想要咨询的问题..." v-model="newMessage"
                            @keyup.enter="sendMessage" />
                        <div class="input-actions">
                            <i class="el-icon-picture" @click="selectImage"></i>
                            <button class="send-btn" @click="sendMessage">发送</button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 聊天会话列表 -->
            <div class="conversation-list">
                <div class="conversation-list-header">
                    <div><i class="el-icon-message-solid"></i>在线咨询</div>
                    <i class="el-icon-arrow-down close" @click="msgBox.show = false"></i>
                </div>

                <div v-for="conv in conversations" :key="conv.id" class="conversation-item"
                    :class="{ active: currentChatGuid === conv.id }" @click="selectConversation(conv)">
                    <div class="conv-header">
                        <div class="user-avatar">
                            <img :src="conv.avatar || agentAvatar" />
                            <span class="unread-dot" v-if="conv.unread > 0 && conv.id !== currentChatGuid"></span>
                        </div>
                        <div class="conv-info">
                            <h4 :class="{ 'has-unread-text': conv.unread > 0 && conv.id !== currentChatGuid }">
                                {{ conv.name }}
                            </h4>
                            <!-- <p class="last-message"
                                :class="{ 'unread-message': conv.unread > 0 && conv.id !== currentChatGuid }">
                                {{ conv.lastMessage || '暂无消息' }}
                            </p> -->
                        </div>
                        <div class="conv-meta">
                            <span class="message-count" v-if="conv.unread > 0 && conv.id !== currentChatGuid">
                                {{ conv.unread > 99 ? '99+' : conv.unread }}
                            </span>
                            <span class="time">{{ conv.time }}</span>
                        </div>
                    </div>
                </div>

                <!-- 空状态提示 -->
                <div v-if="conversations.length === 0" class="empty-conversation">
                    <i class="el-icon-chat-dot-round"></i>
                    <p>暂无会话</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Constant from "@/common/Constant.js"
import { mapState, mapActions } from 'vuex'
import SessionCache from '@/common/Session'
import { EventBus } from '@/common/EventBus'
import uploadImageUtil from '@/common/util/uploadImage.js'

export default {
    name: 'ImDialog',

    data() {
        return {
            agentAvatar: Constant.DEFAULT_AVATAR,
            defaultHouseImage: Constant.DEFAULT_HOUSE,
            msgBox: { show: false },
            chatBox: { show: false },
            newMessage: '',
            conversations: [],      // 会话列表
            messageGroups: [],      // 当前会话消息列表
            currentChatGuid: '',
            currentChatInfo: null,
            isUploading: false,
            isAtBottom: true,
            userHasScrolled: false,

            // 历史消息状态
            isLoadingHistory: false,
            isLoadingMore: false,
            hasMoreHistory: true,
            lastMsgGuid: '',        // 当前最早消息的guid，用于加载更早消息

            // 滚动位置恢复
            scrollHeightBeforeLoad: 0,
            scrollTopBeforeLoad: 0,

            // 新增：禁止滚动的标志
            isScrollLocked: false,  // 是否禁止滚动
            initialLoadCompleted: false, // 初始加载是否完成

            // 其他
            pendingImages: 0,
            processedMessageGuids: new Set(),
            markReadTimer: null,
            refreshTimer: null,
            lastTotalUnread: 0,
            connectionCheckTimer: null,
            lastConnectionState: 'CLOSED',
            pendingFriendGuid: null,
            scrollThrottle: false,
            updateConversationsTimer: null,
            uniqueIdCounter: 0,
            loadingHistoryPromise: null,
            // 添加一个标志来防止重复设置滚动监听
            scrollListenerAttached: false,
        }
    },

    computed: {
        ...mapState({
            user: state => state.user,
            sessionMap: state => state.im?.sessionMap || new Map(),
            friendslist: state => state.im?.friendslist || [],
            userGuid: state => state.im?.userGuid || '',
            isLogin: state => state.im?.isLogin || false,
            imInstance: state => state.im?.imInstans
        }),

        totalUnreadCount() {
            return this.calculateTotalUnread()
        },

        unreadMessagesInCurrentChat() {
            if (!this.currentChatGuid || !this.messageGroups.length) return []
            return this.messageGroups.filter(msg => !msg.isSelf && msg.readStatus !== 1)
        },

        sortedMessageGroups() {
            const groups = Array.isArray(this.messageGroups) ? this.messageGroups : []
            return [...groups].sort((a, b) => (a.time || 0) - (b.time || 0))
        },

        isImReady() {
            return this.isLogin && this.imInstance && this.userGuid
        },
    },

    watch: {
        friendslist: {
            handler(newList) {
                this.buildConversations()
            },
            deep: true,
            immediate: true
        },

        sessionMap: {
            handler(newMap) {
                this.buildConversations()
                if (this.currentChatGuid) {
                    this.loadCurrentSessionMessages()
                }
                this.lastTotalUnread = this.calculateTotalUnread()
            },
            deep: true,
            immediate: true
        },

        currentChatGuid: {
            async handler(newVal, oldVal) {
                if (!newVal || newVal === oldVal) return
                if (this.isLoadingHistory) {
                    await new Promise(resolve => {
                        const checkInterval = setInterval(() => {
                            if (!this.isLoadingHistory) {
                                clearInterval(checkInterval)
                                resolve()
                            }
                        }, 100)
                    })
                }

                // 重置状态
                this.messageGroups = []
                this.hasMoreHistory = true
                this.lastMsgGuid = ''
                this.processedMessageGuids.clear()
                this.isLoadingMore = false

                this.$forceUpdate()

                // 加载历史消息
                await this.loadHistoryMessages(newVal)

                // 标记已读
                const unreadMessages = this.messageGroups.filter(msg => !msg.isSelf && msg.readStatus !== 1)
                if (unreadMessages.length > 0) {
                    unreadMessages.forEach(msg => { msg.readStatus = 1 })
                    await this.markMessagesAsRead({
                        fromGuid: this.userGuid,
                        targetGuid: newVal,
                        msgGuids: unreadMessages.map(msg => msg.id || msg.guid)
                    }).catch(e => console.log('[IM] 标记已读失败:', e))
                    this.updateConversationUnreadCount(newVal, 0, true)
                }

                this.$nextTick(() => {
                    setTimeout(() => {
                        this.scrollToBottom(true)
                        this.userHasScrolled = false
                    }, 200)
                })
            }
        },

        isAtBottom: {
            handler(newVal) {
                if (newVal && this.currentChatGuid) this.markVisibleMessagesAsRead()
            }
        },

        // 监听聊天框显示状态，重新附加滚动监听
        chatBox: {
            handler(newVal) {
                if (newVal.show) {
                    this.$nextTick(() => {
                        this.attachScrollListener()
                    })
                }
            },
            deep: true
        }
    },

    mounted() {
        this.connectAndLogin()
        this.initEventListeners()

        this.refreshTimer = setInterval(() => {
            this.refreshUnreadCount()
        }, 2000)

        this.startConnectionCheck()

        this.$nextTick(() => {
            this.buildConversations()
            this.attachScrollListener()
        })

        setTimeout(() => {
            if (this.isImReady) {
                this.$store.dispatch('im/getFriends', {
                    page: 1,
                    pageSize: 100,
                    append: false,
                    resetPagination: true
                })
            }
        }, 2000)
    },

    beforeDestroy() {
        this.detachScrollListener()
        if (this.refreshTimer) clearInterval(this.refreshTimer)
        if (this.connectionCheckTimer) clearInterval(this.connectionCheckTimer)
        if (this.markReadTimer) clearTimeout(this.markReadTimer)
        if (this.updateConversationsTimer) clearTimeout(this.updateConversationsTimer)

        this.processedMessageGuids.clear()
        this.loadingHistoryPromise = null

        try {
            EventBus.$off('new-message-received', this.handleNewMessage)
            EventBus.$off('refrenshSessionList', this.buildConversations)
            EventBus.$off('force-refresh-conversations', this.buildConversations)
            EventBus.$off('sessions-updated', this.buildConversations)
        } catch (e) {
            console.log('beforeDestroy:', e);
        }
    },

    methods: {
        ...mapActions('im', ['initIM', 'sendTextMsg', 'sendImageMsg', 'getHistory', 'getAllHistory', 'markMessagesAsRead']),

        // ========== 滚动监听管理 ==========
        attachScrollListener() {
            const container = this.$refs.messagesContainer
            if (container && !this.scrollListenerAttached) {
                // 移除可能存在的旧监听，避免重复
                container.removeEventListener('scroll', this.handleScroll)
                container.addEventListener('scroll', this.handleScroll, { passive: true })
                this.scrollListenerAttached = true
            }
        },

        detachScrollListener() {
            const container = this.$refs.messagesContainer
            if (container && this.scrollListenerAttached) {
                container.removeEventListener('scroll', this.handleScroll)
                this.scrollListenerAttached = false
            }
        },

        // ========== 会话列表构建 ==========
        buildConversations() {
            if (this.updateConversationsTimer) {
                clearTimeout(this.updateConversationsTimer)
            }
            this.doBuildConversations()
            this.updateConversationsTimer = setTimeout(() => {
                this.doBuildConversations()
            }, 100)
        },

        doBuildConversations() {
            if (!this.friendslist || this.friendslist.length === 0) {
                this.conversations = []
                this.$forceUpdate()
                return
            }

            const sessionMap = this.sessionMap instanceof Map ? this.sessionMap : new Map()
            const conversationsList = []

            for (const friend of this.friendslist) {
                if (!friend || !friend.agentAccountGuid) continue

                const sessionId = friend.agentAccountGuid
                const session = sessionMap.get(sessionId)

                let unreadCount = 0
                if (session) {
                    unreadCount = session.unreadCount || 0
                    if (this.msgBox.show && sessionId === this.currentChatGuid && this.chatBox.show) {
                        unreadCount = 0
                    }
                }

                let lastMsg = null
                let lastMessage = '暂无消息'
                let lastTime = ''

                if (session) {
                    if (session.lastMsg) {
                        lastMsg = session.lastMsg
                    } else if (session.messages && session.messages.length > 0) {
                        const sortedMsgs = [...session.messages].sort((a, b) => (a.time || 0) - (b.time || 0))
                        lastMsg = sortedMsgs[sortedMsgs.length - 1]
                    }

                    if (lastMsg) {
                        lastMessage = this.getLastMessageDisplay(lastMsg)
                        lastTime = this.formatTime(lastMsg.time)
                    }
                }

                conversationsList.push({
                    id: sessionId,
                    name: friend.agentName || friend.nickName || '经纪人',
                    avatar: friend.agentAvatar || this.agentAvatar,
                    unread: unreadCount,
                    time: lastTime,
                    lastMessage: lastMessage,
                    lastMsgTime: lastMsg?.time || 0,
                    friendInfo: friend
                })
            }

            conversationsList.sort((a, b) => (b.lastMsgTime || 0) - (a.lastMsgTime || 0))

            this.conversations = conversationsList
            this.lastTotalUnread = this.calculateTotalUnread()
            this.$forceUpdate()
        },

        getLastMessageDisplay(msg) {
            if (!msg) return '暂无消息'

            if (msg.contentType === 2) return '[图片]'
            if (msg.contentType === 4) return '[房源]'

            let content = ''
            const msgData = msg.data

            if (typeof msgData === 'string') {
                try {
                    const parsed = JSON.parse(msgData)
                    content = parsed.text || parsed.content || msgData
                } catch {
                    content = msgData
                }
            } else if (msgData) {
                content = msgData.text || msgData.content || ''
            } else if (msg.content) {
                content = msg.content
            }

            if (!content && msgData && typeof msgData !== 'object') {
                content = String(msgData)
            }

            if (!content) return '[消息]'

            if (content.length > 20) {
                return content.substring(0, 20) + '...'
            }
            return content
        },

        formatTime(timestamp) {
            if (!timestamp) return ''
            const date = new Date(timestamp)
            const now = new Date()
            const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
            const yesterday = new Date(today.getTime() - 24 * 60 * 60 * 1000)

            if (date >= today) {
                const hours = date.getHours().toString().padStart(2, '0')
                const minutes = date.getMinutes().toString().padStart(2, '0')
                return `${hours}:${minutes}`
            } else if (date >= yesterday) {
                return '昨天'
            } else {
                const month = (date.getMonth() + 1).toString().padStart(2, '0')
                const day = date.getDate().toString().padStart(2, '0')
                return `${month}-${day}`
            }
        },
        // ========== 加载历史消息 ==========
        async loadHistoryMessages(sessionId) {
            if (!sessionId || !this.userGuid) {
                return { messages: [], hasMore: false }
            }

            if (this.isLoadingHistory) {
                return { messages: [], hasMore: false }
            }

            // 锁定滚动
            this.isScrollLocked = true
            this.isLoadingHistory = true

            try {
                // 循环获取所有历史消息
                let allMessages = []
                let lastMsgGuid = ''
                let loopCount = 0
                const maxLoops = 50

                while (loopCount < maxLoops) {
                    loopCount++
                    const result = await this.$store.dispatch('im/getHistory', {
                        fromGuid: this.userGuid,
                        targetGuid: sessionId,
                        lastMsgGuid: lastMsgGuid
                    })

                    if (result.messages && result.messages.length > 0) {
                        // 去重
                        const existingGuids = new Set(allMessages.map(m => m.guid))
                        const newMessages = result.messages.filter(m => !existingGuids.has(m.guid))

                        if (newMessages.length > 0) {
                            allMessages = [...newMessages, ...allMessages]
                        }

                        // 更新游标为当前页最早的消息 guid（用于获取更早的消息）
                        if (result.messages.length > 0) {
                            const earliestMsgInPage = result.messages[result.messages.length - 1]
                            const newLastMsgGuid = earliestMsgInPage?.guid || ''

                            // 如果 lastMsgGuid 没有变化，说明已经到底了
                            if (newLastMsgGuid === lastMsgGuid) {
                                break
                            }
                            lastMsgGuid = newLastMsgGuid
                        }
                    } else {
                        // 没有返回消息，停止加载
                        break
                    }
                }
                if (allMessages.length > 0) {
                    const formattedMsgs = allMessages.map(m => this.formatMessage(m)).filter(Boolean)
                    formattedMsgs.sort((a, b) => (a.time || 0) - (b.time || 0))

                    formattedMsgs.forEach(msg => {
                        if (!msg.uniqueId) {
                            msg.uniqueId = this.generateUniqueId(msg)
                        }
                    })

                    this.messageGroups = formattedMsgs
                    this.hasMoreHistory = false
                    this.lastMsgGuid = formattedMsgs[0]?.guid || ''
                    this.$forceUpdate()
                    return { messages: formattedMsgs, hasMore: false }
                }

                this.hasMoreHistory = false

                // 如果 API 返回空，从 sessionMap 获取
                const session = this.sessionMap.get(sessionId)
                if (session && session.messages && session.messages.length > 0) {
                    const formattedMsgs = session.messages.map(m => this.formatMessage(m)).filter(Boolean)

                    if (formattedMsgs.length > 0) {
                        formattedMsgs.sort((a, b) => (a.time || 0) - (b.time || 0))
                        formattedMsgs.forEach(msg => {
                            if (!msg.uniqueId) {
                                msg.uniqueId = this.generateUniqueId(msg)
                            }
                        })
                        this.messageGroups = formattedMsgs
                        this.lastMsgGuid = formattedMsgs[0]?.guid || ''
                        this.hasMoreHistory = false
                        this.$forceUpdate()
                    }
                }

                return { messages: [], hasMore: false }
            } catch (error) {
                return { messages: [], hasMore: false, error }
            } finally {
                this.isLoadingHistory = false
                // 解锁滚动，并标记初始加载完成
                this.isScrollLocked = false
                this.initialLoadCompleted = true

                // 等待 DOM 更新后滚动到底部
                this.$nextTick(() => {
                    setTimeout(() => {
                        this.scrollToBottom(true)
                        this.userHasScrolled = false
                    }, 100)
                })
            }
        },
        // ========== 加载更多历史消息 ==========
        async loadMoreHistoryMessages() {
            if (!this.hasMoreHistory) {
                return
            }
            if (this.isLoadingMore) {
                return
            }
            if (!this.currentChatGuid || !this.userGuid) {
                return
            }
            if (!this.hasMoreHistory) {
                return
            }
            // 锁定滚动
            this.isScrollLocked = true
            this.isLoadingMore = true

            const container = this.$refs.messagesContainer
            if (container) {
                this.scrollHeightBeforeLoad = container.scrollHeight
                this.scrollTopBeforeLoad = container.scrollTop
            }

            try {
                const result = await this.$store.dispatch('im/getHistory', {
                    fromGuid: this.userGuid,
                    targetGuid: this.currentChatGuid,
                    lastMsgGuid: this.lastMsgGuid
                })
                if (result.messages && result.messages.length > 0) {
                    const formattedMsgs = result.messages.map(m => this.formatMessage(m)).filter(Boolean)

                    const existingGuids = new Set(this.messageGroups.map(m => m.guid || m.id))
                    const newMessages = formattedMsgs.filter(m => !existingGuids.has(m.guid || m.id))

                    if (newMessages.length > 0) {
                        newMessages.forEach(msg => {
                            if (!msg.uniqueId) {
                                msg.uniqueId = this.generateUniqueId(msg)
                            }
                        })

                        // 将更早的消息添加到前面
                        this.messageGroups = [...newMessages, ...this.messageGroups]
                        this.messageGroups.sort((a, b) => (a.time || 0) - (b.time || 0))

                        if (this.messageGroups.length > 0) {
                            this.lastMsgGuid = this.messageGroups[0]?.guid || ''
                        }

                        const DEFAULT_PAGE_SIZE = 20
                        if (result.messages.length < DEFAULT_PAGE_SIZE) {
                            this.hasMoreHistory = false
                        }
                        this.$forceUpdate()

                        // 恢复滚动位置
                        this.$nextTick(() => {
                            if (container) {
                                const newScrollHeight = container.scrollHeight
                                const heightDiff = newScrollHeight - this.scrollHeightBeforeLoad
                                container.scrollTop = this.scrollTopBeforeLoad + heightDiff
                            }
                        })
                    } else {
                        this.hasMoreHistory = false
                    }
                } else {
                    this.hasMoreHistory = false
                }
            } catch (error) {
                console.error('[IM] 加载更多历史消息失败:', error)
            } finally {
                this.isLoadingMore = false
                // 解锁滚动
                this.isScrollLocked = false
            }
        },
        // ========== 滚动处理 ==========
        handleScroll(e) {
            const container = e.target
            if (!container) {
                return
            }

            // 如果滚动被锁定，阻止滚动事件处理
            if (this.isScrollLocked) {
                return
            }

            if (this.scrollThrottle) return
            this.scrollThrottle = true
            setTimeout(() => { this.scrollThrottle = false }, 150)

            const scrollTop = container.scrollTop
            const scrollHeight = container.scrollHeight
            const clientHeight = container.clientHeight


            // 检测是否在底部
            const isAtBottom = scrollHeight - scrollTop - clientHeight <= 50
            if (isAtBottom !== this.isAtBottom) {
                this.isAtBottom = isAtBottom
                if (isAtBottom) {
                    this.userHasScrolled = false
                    this.markVisibleMessagesAsRead()
                }
            }

            if (!isAtBottom) this.userHasScrolled = true

            // 滚动到顶部加载更多历史消息（距离顶部小于30px时触发）
            if (scrollTop <= 30 && this.hasMoreHistory && !this.isLoadingMore && !this.isLoadingHistory && !this.isScrollLocked) {
                this.loadMoreHistoryMessages()
            }
        },
        scrollToBottom(force = false) {
            const container = this.$refs.messagesContainer
            if (!container) return

            // 如果滚动被锁定且不是强制滚动，则跳过
            if (this.isScrollLocked && !force) {
                return
            }

            if (!force && this.userHasScrolled) return

            this.$nextTick(() => {
                container.scrollTop = container.scrollHeight
                if (force) this.userHasScrolled = false
            })
        },

        // ========== 消息格式处理 ==========
        formatMessage(msg) {
            if (!msg) return null

            const msgId = msg.guid || msg.id || `msg_${Date.now()}_${Math.random()}`
            const isSelf = msg.fromGuid === this.userGuid

            const formattedMsg = {
                id: msgId,
                guid: msgId,
                fromGuid: msg.fromGuid,
                targetGuid: msg.targetGuid,
                time: msg.time || Date.now(),
                isSelf: isSelf,
                contentType: msg.contentType || 1,
                readStatus: msg.readStatus || 0,
                content: ''
            }

            try {
                const rawData = msg.data

                if (msg.contentType === 1) {
                    if (typeof rawData === 'string') {
                        try {
                            const parsed = JSON.parse(rawData)
                            formattedMsg.content = parsed.text || parsed.content || rawData
                        } catch {
                            formattedMsg.content = rawData
                        }
                    } else if (rawData && typeof rawData === 'object') {
                        formattedMsg.content = rawData.text || rawData.content || JSON.stringify(rawData)
                    } else if (msg.content) {
                        formattedMsg.content = msg.content
                    } else {
                        formattedMsg.content = String(rawData || '[文本消息]')
                    }
                } else if (msg.contentType === 2) {
                    let url = ''
                    if (typeof rawData === 'string') {
                        try {
                            const parsed = JSON.parse(rawData)
                            url = parsed.url || parsed
                        } catch {
                            url = rawData
                        }
                    } else if (rawData && typeof rawData === 'object') {
                        url = rawData.url || ''
                    }
                    formattedMsg.content = url || '[图片]'
                } else if (msg.contentType === 4) {
                    // 房源消息处理 - 增强 houseData
                    let houseData = rawData
                    if (typeof rawData === 'string') {
                        try {
                            houseData = JSON.parse(rawData)
                        } catch (e) {
                            houseData = {}
                        }
                    }

                    // ========== 新增：计算 priceShow 和 unitPrice ==========
                    if (houseData && houseData.tradeType === 2) {
                        // 售价房源：计算 priceShow（万元，四舍五入取整）
                        const priceInWan = houseData.price / 10000
                        houseData.priceShow = Math.round(priceInWan)

                        // 计算 unitPrice（元/㎡，总价除以建筑面积）
                        if (houseData.buildingArea && houseData.buildingArea > 0) {
                            houseData.unitPrice = Math.round(houseData.price / houseData.buildingArea)
                        } else {
                            houseData.unitPrice = 0
                        }
                    } else if (houseData && houseData.tradeType === 1) {
                        // 租房房源：不需要这些字段，但为了统一可以保留
                        houseData.priceShow = houseData.rentPrice || 0
                        houseData.unitPrice = 0
                    }

                    formattedMsg.houseData = houseData
                    formattedMsg.content = houseData.title || '[房源]'
                } else {
                    formattedMsg.content = msg.content || '[其他消息]'
                }

                if (!formattedMsg.content) {
                    formattedMsg.content = '[消息]'
                }
            } catch (error) {
                console.error('[IM] formatMessage 错误:', error, msg)
                formattedMsg.content = '[消息格式错误]'
            }

            return formattedMsg
        },

        generateUniqueId(msg) {
            this.uniqueIdCounter++
            return `${msg.guid || msg.id}_${Date.now()}_${this.uniqueIdCounter}`
        },

        // ========== 处理原始消息 ==========
        handleRawMessage(data) {
            if (!data) return

            let messages = []
            if (data.messages) {
                messages = Array.isArray(data.messages) ? data.messages : [data.messages]
            } else if (data.data) {
                messages = Array.isArray(data.data) ? data.data : [data.data]
            } else if (data.msg) {
                messages = Array.isArray(data.msg) ? data.msg : [data.msg]
            }

            if (!messages.length) return

            messages.forEach(msg => {
                if (!msg || !msg.guid) return
                if (this.processedMessageGuids.has(msg.guid)) return
                this.processedMessageGuids.add(msg.guid)

                const sessionId = msg.fromGuid === this.userGuid ? msg.targetGuid : msg.fromGuid
                if (!sessionId) return

                const isCurrentSession = sessionId === this.currentChatGuid
                const formattedMsg = this.formatMessage(msg)
                if (!formattedMsg) return

                this.$store.commit('im/ADD_MESSAGE_TO_SESSION', { sessionId, message: msg })

                if (isCurrentSession) {
                    if (this.isAtBottom) {
                        formattedMsg.readStatus = 1
                    }

                    formattedMsg.uniqueId = this.generateUniqueId(formattedMsg)

                    const exists = this.messageGroups.some(m => (m.guid || m.id) === formattedMsg.guid)
                    if (!exists) {
                        this.messageGroups.push(formattedMsg)
                        this.messageGroups.sort((a, b) => (a.time || 0) - (b.time || 0))
                        this.$forceUpdate()

                        if (this.isAtBottom) {
                            this.$nextTick(() => this.scrollToBottom(true))
                        }
                    }
                }

                if (!formattedMsg.isSelf) {
                    this.updateConversationUnreadCount(sessionId, 1)
                }
            })

            this.lastTotalUnread = this.calculateTotalUnread()
            this.buildConversations()
        },

        handleNewMessage(data) {
            this.handleRawMessage(data)
            this.refreshUnreadCount()
        },

        async sendMessage() {
            if (!this.newMessage.trim() || !this.currentChatGuid) return

            const msgData = this.newMessage.trim()
            this.newMessage = ''

            const tempMsg = {
                guid: `temp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
                fromGuid: this.userGuid,
                targetGuid: this.currentChatGuid,
                contentType: 1,
                data: msgData,
                time: Date.now(),
                readStatus: 1
            }

            const formattedMsg = this.formatMessage(tempMsg)
            formattedMsg.uniqueId = this.generateUniqueId(formattedMsg)
            this.messageGroups.push(formattedMsg)
            this.messageGroups.sort((a, b) => (a.time || 0) - (b.time || 0))
            this.$forceUpdate()
            this.scrollToBottom(true)

            try {
                await this.sendTextMsg({
                    fromGuid: this.userGuid,
                    targetGuid: this.currentChatGuid,
                    text: msgData
                })
            } catch (error) {
                console.error('[IM] 发送消息失败:', error)
                if (this.$message) this.$message.error('发送失败')
            }
        },

        loadCurrentSessionMessages() {
            if (!this.currentChatGuid) return

            const session = this.sessionMap instanceof Map ? this.sessionMap.get(this.currentChatGuid) : null
            let messages = session?.messages || []

            if (messages.length > 0 && this.messageGroups.length === 0) {
                const formattedMessages = messages.map(msg => this.formatMessage(msg)).filter(Boolean)
                formattedMessages.sort((a, b) => (a.time || 0) - (b.time || 0))
                formattedMessages.forEach(msg => {
                    if (!msg.uniqueId) msg.uniqueId = this.generateUniqueId(msg)
                })
                this.messageGroups = formattedMessages
                this.$forceUpdate()
            }
        },
        async selectConversation(conv) {
            if (!conv || !conv.id) return
            if (conv.id === this.currentChatGuid) {
                this.chatBox.show = true
                return
            }

            // 重置初始加载完成标志
            this.initialLoadCompleted = false
            this.messageGroups = []
            this.hasMoreHistory = true
            this.lastMsgGuid = ''
            this.currentChatGuid = conv.id
            this.currentChatInfo = conv
            this.chatBox.show = true
            this.processedMessageGuids.clear()
            this.isLoadingHistory = false
            this.isLoadingMore = false
            // 重置滚动锁定
            this.isScrollLocked = false

            this.$forceUpdate()

            // 重新附加滚动监听
            this.$nextTick(() => {
                this.attachScrollListener()
            })

            const result = await this.loadHistoryMessages(conv.id)
            const unreadMessages = this.messageGroups.filter(msg => !msg.isSelf && msg.readStatus !== 1)
            if (unreadMessages.length > 0) {
                unreadMessages.forEach(msg => { msg.readStatus = 1 })
                await this.markMessagesAsRead({
                    fromGuid: this.userGuid,
                    targetGuid: conv.id,
                    msgGuids: unreadMessages.map(msg => msg.id || msg.guid)
                }).catch(e => console.log('标记已读失败:', e))
                this.updateConversationUnreadCount(conv.id, -unreadMessages.length)
            } else {
                this.updateConversationUnreadCount(conv.id, 0, true)
            }

            this.$nextTick(() => {
                setTimeout(() => {
                    // 只有初始加载完成后才滚动
                    if (this.initialLoadCompleted) {
                        this.scrollToBottom(true)
                        this.userHasScrolled = false
                    }
                }, 200)
            })

            this.$forceUpdate()
        },

        backToConversationList() {
            this.chatBox.show = false
            this.currentChatGuid = null
            this.currentChatInfo = null
            this.messageGroups = []
            this.hasMoreHistory = true
            this.lastMsgGuid = ''
            this.buildConversations()
            this.detachScrollListener()
        },

        calculateTotalUnread() {
            if (!this.sessionMap || !(this.sessionMap instanceof Map)) return 0

            let total = 0
            for (const [sessionId, session] of this.sessionMap) {
                if (!session) continue
                if (this.msgBox.show && sessionId === this.currentChatGuid && this.chatBox.show) continue
                total += session.unreadCount || 0
            }
            return total
        },

        refreshUnreadCount() {
            this.buildConversations()
            this.lastTotalUnread = this.calculateTotalUnread()
        },

        updateConversationUnreadCount(sessionId, change, forceSetZero = false) {
            const session = this.sessionMap.get(sessionId)
            if (session) {
                if (forceSetZero) {
                    session.unreadCount = 0
                } else {
                    session.unreadCount = Math.max(0, (session.unreadCount || 0) + change)
                }
                this.$store.commit('im/UPDATE_UNREAD_COUNT', {
                    sessionId,
                    unreadCount: session.unreadCount
                })
            }

            const convIndex = this.conversations.findIndex(c => c.id === sessionId)
            if (convIndex !== -1) {
                const conv = { ...this.conversations[convIndex] }
                if (forceSetZero) {
                    conv.unread = 0
                } else {
                    conv.unread = Math.max(0, (conv.unread || 0) + change)
                }
                this.$set(this.conversations, convIndex, conv)
            }

            this.lastTotalUnread = this.calculateTotalUnread()
        },

        markVisibleMessagesAsRead() {
            if (!this.currentChatGuid || !this.$refs.messagesContainer) return

            const visibleUnreadMessages = this.unreadMessagesInCurrentChat
            if (visibleUnreadMessages.length === 0) return

            if (this.markReadTimer) clearTimeout(this.markReadTimer)

            this.markReadTimer = setTimeout(async () => {
                try {
                    visibleUnreadMessages.forEach(msg => { msg.readStatus = 1 })
                    await this.markMessagesAsRead({
                        fromGuid: this.userGuid,
                        targetGuid: this.currentChatGuid,
                        msgGuids: visibleUnreadMessages.map(msg => msg.id || msg.guid)
                    })
                    this.updateConversationUnreadCount(this.currentChatGuid, -visibleUnreadMessages.length)
                    this.markReadTimer = null
                    this.$forceUpdate()
                } catch (error) {
                    console.error('[IM] 标记已读失败:', error)
                }
            }, 300)
        },

        onImageLoad() {
            this.pendingImages = Math.max(0, this.pendingImages - 1)
        },

        onImageError() {
            this.pendingImages = Math.max(0, this.pendingImages - 1)
        },

        previewImage(url) {
            window.open(url, '_blank')
        },

        selectImage() {
            const input = document.createElement('input')
            input.type = 'file'
            input.accept = 'image/*'
            input.onchange = (e) => {
                const file = e.target.files[0]
                if (file) this.uploadImage(file)
            }
            input.click()
        },

        async uploadImage(file) {
            if (this.isUploading) return
            this.isUploading = true

            try {
                const formData = new FormData()
                formData.append('file', file)
                formData.append('token', uploadImageUtil.uploadToken)

                const result = await this.uploadFileToQiniu(formData, file.name)
                const imageUrl = uploadImageUtil.imgUrl + result.key

                await this.sendImageMsg({
                    fromGuid: this.userGuid,
                    targetGuid: this.currentChatGuid,
                    msgData: { url: imageUrl }
                })
            } catch (error) {
                console.error('[IM] 上传图片失败:', error)
                if (this.$message) this.$message.error('图片上传失败')
            } finally {
                this.isUploading = false
            }
        },

        uploadFileToQiniu(formData, fileName) {
            return new Promise((resolve, reject) => {
                const xhr = new XMLHttpRequest()
                xhr.open('POST', uploadImageUtil.uploadUrl, true)
                xhr.onload = () => {
                    if (xhr.status === 200) {
                        try {
                            resolve(JSON.parse(xhr.responseText))
                        } catch {
                            resolve({ key: fileName })
                        }
                    } else {
                        reject(new Error('上传失败 (' + xhr.status + ')'))
                    }
                }
                xhr.onerror = () => reject(new Error('网络连接失败'))
                xhr.ontimeout = () => reject(new Error('上传超时'))
                xhr.timeout = 30000
                xhr.send(formData)
            })
        },

        goToHouseDetail(houseData) {
            if (!houseData || !houseData.guid) return
            const route = this.$router.resolve({
                path: '/houseDetail/' + (houseData.tradeType || 2),
                query: { guid: houseData.guid }
            })
            window.open(route.href, '_blank')
        },

        async openMsgBox() {
            this.msgBox.show = true
            if (!this.isImReady) await this.connectAndLogin()

            if (!this.friendslist || this.friendslist.length === 0) {
                await this.$store.dispatch('im/resetAndLoadFriends')
            } else {
                await this.$store.dispatch('im/getFriends', {
                    page: 1,
                    pageSize: 100,
                    append: false,
                    resetPagination: true
                })
            }
            this.refreshUnreadCount()
        },

        async connectAndLogin() {
            try {
                const token = SessionCache.getAccessToken()
                const customerInfo = SessionCache.getCustomerInfo()
                if (!token || !customerInfo?.account?.guid) return
                if (this.isLogin && this.imInstance) return

                await this.initIM({
                    account: customerInfo.account.guid,
                    token: token,
                    callbackv2: () => {
                        setTimeout(() => {
                            this.refreshUnreadCount()
                            this.buildConversations()
                        }, 500)
                    }
                })
            } catch (error) {
                console.error('[IM] 连接失败:', error)
            }
        },

        handleOpenIMDialog(agentInfo) {
            this.msgBox.show = true
            this.chatBox.show = true

            if (agentInfo?.agentAccountGuid) {
                this.pendingFriendGuid = agentInfo.agentAccountGuid
                const conv = this.conversations.find(c => c.id === agentInfo.agentAccountGuid)
                if (conv) {
                    this.selectConversation(conv)
                    this.pendingFriendGuid = null
                } else {
                    const trySelect = (attempts = 0) => {
                        if (attempts > 10) return
                        const updatedConv = this.conversations.find(c => c.id === agentInfo.agentAccountGuid)
                        if (updatedConv) {
                            this.selectConversation(updatedConv)
                            this.pendingFriendGuid = null
                        } else {
                            setTimeout(() => trySelect(attempts + 1), 300)
                        }
                    }
                    trySelect()
                }
            }
        },

        startConnectionCheck() {
            this.connectionCheckTimer = setInterval(() => {
                const state = this.getConnectionState()
                if (state !== this.lastConnectionState) this.lastConnectionState = state
                if (state !== 'OPEN' && this.isLogin) this.connectAndLogin()
            }, 5000)
        },

        getConnectionState() {
            if (this.imInstance?.clientStater) {
                return this.imInstance.clientStater.getConnectionState()
            }
            return 'CLOSED'
        },

        initEventListeners() {
            EventBus.$on('open-im-dialog', this.handleOpenIMDialog)
            EventBus.$on('refrenshSessionList', () => {
                this.buildConversations()
            })
            EventBus.$on('new-message-received', this.handleNewMessage)
            EventBus.$on('force-refresh-conversations', () => {
                this.buildConversations()
                this.$forceUpdate()
            })
            EventBus.$on('sessions-updated', () => {
                this.buildConversations()
            })

            this.$watch(
                () => this.imInstance?.clientStater,
                (clientStater) => {
                    if (clientStater) clientStater.setOnMessageCallback(this.handleRawMessage)
                },
                { immediate: true }
            )
        }
    }
}
</script>

<style scoped lang="less">
.fixed {
    position: fixed;
    right: 4px;
    bottom: 10px;
    color: #000;
    font-size: 20px;
    z-index: 9999;

    .msgTips {
        cursor: pointer;
        position: absolute;
        right: 0;
        bottom: 0;
        width: 200px;
        height: 30px;
        display: flex;
        align-items: center;
        color: #333;
        font-size: 14px;
        background-color: #fff;
        box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.1);
        border-radius: 5px;
        border: 1px solid #ccc;
        padding-left: 10px;
        position: relative;
        overflow: visible;

        i {
            color: #00ae66;
            font-size: 18px;
            margin-right: 16px;
        }

        .unread-count {
            min-width: 20px;
            height: 20px;
            line-height: 20px;
            text-align: center;
            background-color: #ff4d4f;
            color: #fff;
            border-radius: 10px;
            font-size: 11px;
            font-weight: 500;
            padding: 0 4px;
            margin-left: 6px;
            z-index: 2;
        }
    }

    .msgBox {
        height: 420px;
        position: absolute;
        right: 0;
        bottom: 0;
        display: flex;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.6);

        .chatBox {
            display: flex;
            flex-direction: column;
            width: 500px;
        }

        .conversation-list {
            height: auto;
            width: 260px;
            padding: 0 12px 12px;
            background: #fff;
            border-left: 1px solid #eee;
            border-right: none;
            overflow-y: auto;

            &-header {
                font-size: 14px;
                margin-bottom: 16px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                color: #666;
                padding-top: 16px;
                position: sticky;
                top: 0;
                background: #fff;
                z-index: 1;

                div {
                    display: flex;
                    align-items: center;

                    i {
                        margin-right: 8px;
                        color: #00ae66;
                    }
                }

                .close {
                    cursor: pointer;
                    font-size: 16px;

                    &:hover {
                        color: #333;
                    }
                }
            }

            .empty-conversation {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                padding: 40px 20px;
                color: #999;

                i {
                    font-size: 48px;
                    margin-bottom: 12px;
                    color: #ddd;
                }

                p {
                    font-size: 14px;
                    margin: 0;
                }
            }
        }

        .conversation-item {
            cursor: pointer;
            margin-bottom: 12px;
            border-radius: 8px;
            overflow: hidden;
            border: 1px solid transparent;
            transition: all 0.3s;

            &:hover {
                border: 1px solid #eeeeee;
                background: #f9f9f9;
            }

            &.active {
                border: 1px solid #00ae66;
                box-shadow: 0 0px 8px 1px rgba(0, 174, 102, 0.1);
                background: #f0faf5;
            }
        }

        .conv-header {
            display: flex;
            align-items: center;
            padding: 8px;
            position: relative;
        }

        .user-avatar {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            margin-right: 12px;
            position: relative;

            img {
                width: 40px;
                height: 40px;
                border-radius: 50%;
                object-fit: cover;
            }

            .unread-dot {
                position: absolute;
                top: -2px;
                right: -2px;
                width: 10px;
                height: 10px;
                border-radius: 50%;
                background-color: #ff4d4f;
                border: 2px solid #fff;
            }
        }

        .conv-info {
            flex: 1;
            min-width: 0;

            h4 {
                margin: 0 0 4px 0;
                font-size: 14px;
                color: #333;
                font-weight: 500;

                &.has-unread-text {
                    color: #ff4d4f;
                    font-weight: 600;
                }
            }

            .last-message {
                margin: 0;
                font-size: 12px;
                color: #999;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                display: flex;
                align-items: center;
                gap: 6px;

                &.unread-message {
                    color: #ff4d4f;
                    font-weight: 500;
                }
            }
        }

        .conv-meta {
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            min-width: 60px;
        }

        .message-count {
            display: inline-block;
            min-width: 20px;
            height: 20px;
            line-height: 20px;
            text-align: center;
            background: #ff4d4f;
            color: white;
            border-radius: 10px;
            font-size: 11px;
            padding: 0 6px;
            margin-bottom: 4px;
            font-weight: 500;
        }

        .time {
            font-size: 11px;
            color: #999;
        }

        .chat-content {
            flex: 1;
            background: #f5f5f5;
            display: flex;
            flex-direction: column;
            position: relative;
        }

        .message-group {
            display: flex;
            flex-direction: column;
            height: 350px;
            background: #fff;
            border-radius: 8px 0 0 0;
        }

        .message-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 12px 16px;
            border-bottom: 1px solid #eee;
            flex-shrink: 0;

            h4 {
                font-size: 15px;
                color: #333;
                font-weight: 500;
                margin: 0;
            }

            .header-actions {
                display: flex;
                align-items: center;
                gap: 12px;
            }

            .back {
                font-size: 18px;
                color: #999;
                cursor: pointer;

                &:hover {
                    color: #333;
                }
            }
        }

        .messages {
            flex: 1;
            overflow-y: auto;
            display: flex;
            flex-direction: column;
            gap: 12px;
            padding: 16px;
            height: 400px;
            position: relative;
            background: #fff;

            // 加载中的遮罩效果（可选）
            &.scroll-locked {
                overflow: hidden !important;
            }
        }

        // 全局加载遮罩（可选）
        .im-loading-overlay {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(255, 255, 255, 0.8);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 100;
            border-radius: 8px;

            .loading-spinner {
                display: flex;
                flex-direction: column;
                align-items: center;

                i {
                    font-size: 32px;
                    color: #00ae66;
                    animation: rotate 1s linear infinite;
                    margin-bottom: 12px;
                }

                span {
                    font-size: 14px;
                    color: #666;
                }
            }
        }

        .top-loading-more {
            text-align: center;
            padding: 12px;
            color: #00ae66;
            font-size: 13px;
            background: #f8f9fa;
            border-radius: 20px;
            margin: 8px auto;
            width: fit-content;
            position: sticky;
            top: 0;
            z-index: 10;

            i {
                margin-right: 6px;
                animation: rotate 1s linear infinite;
            }
        }

        .no-more-history {
            text-align: center;
            padding: 12px;
            color: #999;
            font-size: 12px;
            border-bottom: 1px solid #f0f0f0;
            margin-bottom: 8px;

            span {
                background: #f5f5f5;
                padding: 4px 12px;
                border-radius: 20px;
            }
        }

        .empty-messages {
            text-align: center;
            padding: 60px 20px;
            color: #999;

            i {
                font-size: 48px;
                margin-bottom: 16px;
                color: #ddd;
            }

            p {
                font-size: 14px;
                margin: 0;
            }
        }

        @keyframes rotate {
            from {
                transform: rotate(0deg);
            }

            to {
                transform: rotate(360deg);
            }
        }

        .message-item {
            display: flex;
            align-items: flex-start;
            width: 100%;
            position: relative;

            .avatar {
                width: 36px;
                height: 36px;
                border-radius: 50%;
                overflow: hidden;
                flex-shrink: 0;
                position: relative;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }

            .message-bubble {
                max-width: 70%;
                padding: 10px 14px;
                border-radius: 18px;
                font-size: 14px;
                line-height: 1.5;
                word-break: break-word;
                position: relative;
                margin: 0 10px;

                .message-image {
                    max-width: 200px;
                    max-height: 200px;
                    border-radius: 8px;
                    cursor: pointer;
                    transition: opacity 0.3s;

                    &:hover {
                        opacity: 0.9;
                    }
                }

                &.house-card {
                    padding: 0;
                    background: transparent !important;

                    .house-card-content {
                        display: flex;
                        flex-direction: column;
                        width: 280px;
                        background: #fff;
                        border-radius: 12px;
                        overflow: hidden;
                        cursor: pointer;
                        transition: all 0.3s;
                        border: 1px solid #eee;

                        &:hover {
                            box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.1);
                            border-color: #00ae66;
                        }

                        .house-image {
                            width: 100%;
                            height: 160px;
                            object-fit: cover;
                        }

                        .house-info {
                            padding: 12px;

                            .house-title {
                                font-size: 16px;
                                font-weight: 500;
                                color: #333;
                                margin-bottom: 8px;
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                            }

                            .house-desc {
                                font-size: 13px;
                                color: #666;
                                margin-bottom: 8px;

                                span {
                                    margin-right: 12px;

                                    &:last-child {
                                        margin-right: 0;
                                    }
                                }
                            }

                            .house-price {
                                font-size: 18px;
                                font-weight: 600;
                                color: #f40;
                                margin-bottom: 8px;

                                .unit-price {
                                    font-size: 12px;
                                    font-weight: normal;
                                    color: #999;
                                    margin-left: 8px;
                                }
                            }
                        }
                    }
                }
            }

            &.self {
                flex-direction: row-reverse;

                .avatar {
                    margin-left: 10px;
                    margin-right: 0;
                }

                .message-bubble {
                    background-color: #00ae66;
                    color: white;

                    &.house-card {
                        background: transparent !important;
                    }
                }
            }

            &.other {
                flex-direction: row;

                .avatar {
                    margin-right: 10px;
                }

                .message-bubble {
                    background-color: #f0f0f0;
                    color: #333;
                }
            }
        }

        .message-input-area {
            background: #fff;
            border-top: 1px solid #eee;
            border-radius: 0 0 0 8px;
            flex-shrink: 0;

            .message-input-wrapper {
                display: flex;
                align-items: center;
                padding: 12px 16px;

                input {
                    flex: 1;
                    height: 40px;
                    padding: 0 16px;
                    border: 1px solid #ddd;
                    border-radius: 20px;
                    outline: none;
                    font-size: 14px;
                    transition: all 0.3s;

                    &:focus {
                        border-color: #00ae66;
                        box-shadow: 0 0 0 2px rgba(0, 174, 102, 0.1);
                    }
                }

                .input-actions {
                    display: flex;
                    align-items: center;
                    margin-left: 12px;

                    i {
                        font-size: 24px;
                        color: #666;
                        margin-right: 12px;
                        cursor: pointer;
                        transition: color 0.3s;

                        &:hover {
                            color: #00ae66;
                        }
                    }

                    .send-btn {
                        width: 70px;
                        height: 40px;
                        background: #00ae66;
                        color: white;
                        border: none;
                        border-radius: 20px;
                        cursor: pointer;
                        font-size: 14px;
                        font-weight: 500;
                        transition: all 0.3s;

                        &:hover {
                            background: #009955;
                            transform: scale(1.02);
                        }

                        &:active {
                            transform: scale(0.98);
                        }
                    }
                }
            }
        }
    }
}
</style>